import React from 'react';
import {AbsoluteFill,Audio,Sequence,staticFile,useCurrentFrame,useVideoConfig} from 'remotion';
import {COLORS,FONTS} from '../../coldcompute/theme';
import {Fonts} from '../../coldcompute/Fonts';
import {NotebookScene} from './scenes';
import episodes from './episodes.json';
import timing from './timing.json';
import {ExpandedContextVideo,ExpandedContextThumb,expandedContextDuration} from './expanded';
import {NativeContextManagement,NativeContextThumb,NATIVE_CONTEXT_FRAMES} from '../context-management-native';
import {ContextManagementLesson,ContextManagementLessonThumb,CONTEXT_LESSON_FRAMES} from '../context-management-lesson';
import {ConnectorsLesson,ConnectorsLessonThumb,CONNECTORS_LESSON_FRAMES} from '../connectors-lesson';

const NarratedScene:React.FC<{episode:number;scene:number}>=({episode,scene})=>{
 const frame=useCurrentFrame(),{fps}=useVideoConfig(),clip=timing.episodes[episode].scenes[scene];
 const sec=frame/fps;
 const cue=clip.captions.find(c=>sec>=c.start&&sec<c.end);
 return <>
  <NotebookScene episode={episode} scene={scene}/>
  <Sequence from={clip.leadFrames}><Audio src={staticFile(clip.audio)}/></Sequence>
  {cue&&<AbsoluteFill style={{justifyContent:'flex-end',alignItems:'center',paddingBottom:84,pointerEvents:'none'}}><div style={{maxWidth:1650,padding:'10px 25px',borderRadius:10,background:'rgba(11,13,18,.94)',color:COLORS.text,fontFamily:FONTS.body,fontSize:38,lineHeight:1.25,textAlign:'center'}}>{cue.text}</div></AbsoluteFill>}
 </>;
};
export const NotebookVideo:React.FC<{episode:number}>=({episode})=> <><Fonts/>{timing.episodes[episode].scenes.map((s,i)=><Sequence key={i} from={s.startFrame} durationInFrames={s.durationFrames}><NarratedScene episode={episode} scene={i}/></Sequence>)}</>;

const existingNotebookEntries=episodes.map((e,i)=>({
 id:e.composition_id,
 component:i===0?ExpandedContextVideo:()=> <NotebookVideo episode={i}/>,
 thumb:i===0?ExpandedContextThumb:()=> <><Fonts/><NotebookScene episode={i} scene={0} thumbnail/></>,
 duration:i===0?expandedContextDuration:timing.episodes[i].durationFrames,
}));

export const builderNotebookEntries=[existingNotebookEntries[0],{
 id:'48-ContextManagementNative',
 component:NativeContextManagement,
 thumb:NativeContextThumb,
 duration:NATIVE_CONTEXT_FRAMES,
},{
 id:'48-ContextManagementRevised',
 component:ContextManagementLesson,
 thumb:ContextManagementLessonThumb,
 duration:CONTEXT_LESSON_FRAMES,
},{
 id:'49-ConnectorsRevised',
 component:ConnectorsLesson,
 thumb:ConnectorsLessonThumb,
 duration:CONNECTORS_LESSON_FRAMES,
},...existingNotebookEntries.slice(1)];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
